import TileActions from "./TileActions.vue";
import { pluginify } from "./../../util";
export default pluginify(TileActions);
export { TileActions };
